const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h56v56H0z" />
        <path
            d="M7 27.748c0 .62.222 1.149.667 1.585.445.436.97.654 1.574.654h16.291v16.272c0 .603.218 1.127.655 1.571.436.445.965.667 1.586.667.621 0 1.154-.222 1.6-.667.444-.444.666-.968.666-1.571V29.987h16.266c.605 0 1.13-.218 1.574-.654.445-.436.667-.964.667-1.585 0-.62-.222-1.152-.667-1.597-.445-.444-.97-.666-1.574-.666H30.04V9.238c0-.603-.222-1.127-.667-1.572A2.182 2.182 0 0027.773 7c-.62 0-1.15.222-1.586.666a2.17 2.17 0 00-.655 1.572v16.247H9.241c-.604 0-1.129.222-1.574.666A2.177 2.177 0 007 27.748z"
            fill="currentColor" fill-rule="nonzero" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=plus.es.DnSprf-2.js.map
